// extracted by mini-css-extract-plugin
export default {"row":"view-row-answer-quotation_row__oxstV"};